export enum AssetOptionKeyEnum {
    SOFTWARE = 'softwares',
    ZONE = 'zones',
    SYSTEM = 'systems',
    PHYSICAL_INTERFACE = 'physicalInterfaces',
    COMMUNICATION_PROTOCOL = 'communicationProtocols',
    ASSET_TYPE = 'assetTypes',
    LIFECYCLE_STATUS = 'lifecycleStatuses',
    USERS = 'users',
}
